export { QuickSearchProvider, useQuickSearchContext } from "./QuickSearchContext";
export { useRateQuickSearch } from "./useRateQuickSearch";
export type { UseRateQuickSearchResult } from "./useRateQuickSearch";

export const QUICK_SEARCH_MIN_RATES = 10;
